export type CargoMultiSelectionCategory =
  | { key: "rack:bin"; kind: "rack"; label: "料箱货架"; rackType: "bin" }
  | { key: "rack:pallet"; kind: "rack"; label: "横梁式货架"; rackType: "pallet" }
  | {
      blockPrefix: string;
      key: `device:${string}`;
      kind: "device";
      label: string;
    }
  | {
      key: "pallet-reciprocating-lift";
      kind: "pallet-reciprocating-lift";
      label: "托盘往复式提升机";
    }
  | {
      key: "single-station-reciprocating-shuttle";
      kind: "single-station-reciprocating-shuttle";
      label: "单工位往复式穿梭车";
    }
  | {
      key: "pallet-stacker-crane";
      kind: "pallet-stacker-crane";
      label: "托盘堆垛机";
    };

export type CargoMultiSelectionGroup = {
  category: CargoMultiSelectionCategory;
  ids: string[];
};

export type CargoMultiSelectionTarget = {
  category: CargoMultiSelectionCategory;
  id: string;
};

export type CargoMultiSelectionToggleResult = {
  group?: CargoMultiSelectionGroup;
  rejected: boolean;
};

export function createRackSelectionCategory(
  rackType: "bin" | "pallet"
): CargoMultiSelectionCategory {
  return rackType === "bin"
    ? { key: "rack:bin", kind: "rack", label: "料箱货架", rackType }
    : { key: "rack:pallet", kind: "rack", label: "横梁式货架", rackType };
}

export function createDeviceSelectionCategory(blockPrefix: string): CargoMultiSelectionCategory {
  return {
    blockPrefix,
    key: `device:${blockPrefix}`,
    kind: "device",
    label: `设备 · ${blockPrefix}`
  };
}

export const palletReciprocatingLiftSelectionCategory: CargoMultiSelectionCategory = {
  key: "pallet-reciprocating-lift",
  kind: "pallet-reciprocating-lift",
  label: "托盘往复式提升机"
};

export const singleStationReciprocatingShuttleSelectionCategory: CargoMultiSelectionCategory = {
  key: "single-station-reciprocating-shuttle",
  kind: "single-station-reciprocating-shuttle",
  label: "单工位往复式穿梭车"
};
export const palletStackerCraneSelectionCategory: CargoMultiSelectionCategory = {
  key: "pallet-stacker-crane",
  kind: "pallet-stacker-crane",
  label: "托盘堆垛机"
};

export function toggleCargoMultiSelection(
  current: CargoMultiSelectionGroup | undefined,
  target: CargoMultiSelectionTarget
): CargoMultiSelectionToggleResult {
  if (!current) {
    return {
      group: { category: target.category, ids: [target.id] },
      rejected: false
    };
  }

  const selectedIndex = current.ids.indexOf(target.id);
  if (selectedIndex >= 0) {
    const ids = current.ids.filter((_, index) => index !== selectedIndex);
    return {
      group: ids.length > 0 ? { category: current.category, ids } : undefined,
      rejected: false
    };
  }

  if (current.category.key !== target.category.key) {
    return { group: current, rejected: true };
  }

  return {
    group: { category: current.category, ids: [...current.ids, target.id] },
    rejected: false
  };
}
